var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-content-wrap" },
    [
      _vm.isCompanyStaffAccess
        ? _c("setting-header", {
            staticClass: "hide-for-print",
            attrs: {
              breadcrumbs: [
                { name: "求人確認" },
                {
                  name: "掲載済みの求人・応募フォームタイプ設定",
                  pathName: "jobPublished",
                },
              ],
              title: "掲載済みの求人プレビュー",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid-x hide-for-print",
          attrs: { "data-test": "usage-notes-and-print-button" },
        },
        [
          _c(
            "div",
            { staticClass: "cell auto pega-usage-notes" },
            [
              _c("job-preview-provision-list-link", {
                staticClass: "pega-accordion-link-header",
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("print-button", {
            staticClass: "cell shrink",
            attrs: { "is-simple": false },
            on: { print: _vm.print },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid-x margin-bottom-1",
          attrs: { "data-test": "sp-preview-button" },
        },
        [
          _c(
            "div",
            { staticClass: "cell hide-for-print" },
            [
              _c("sp-preview-button", {
                attrs: {
                  id: Number(_vm.offerId),
                  "route-name": _vm.spRouteNameForJob,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "cell pega-text-small" }, [
            _vm._v(
              "\n      ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。\n    "
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isFinishCreated
        ? _c(
            "div",
            [
              _c("job-preview", { attrs: { offer: _vm.offer } }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("job-matching", {
                attrs: {
                  "job-category-settings": _vm.offer.jobCategorySettings,
                  matching: _vm.matching,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "pega-hide-msg" }, [
      _vm._v(
        "\n      これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。"
      ),
      _c("br"),
      _vm._v("\n      あらかじめご了承ください。\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }